import React from "react";
import PropTypes from "prop-types";

import Tile, {
  TileTitle,
  TileHeader,
  TileBody
} from "shared/react_components/Tile";
import DataList from "shared/react_components/DataList";

import OptionalDatumCol from "./OptionalDatumCol";

const CampaignData = ({ aliases, affiliateIdFromNetwork, affiliateName, campaignId, campaignFullName, campaignCountry, adwordsData }) => {
  return (
    <Tile style={{ height: 400 }}>
      <TileHeader>
        <TileTitle>Campaign Data</TileTitle>
      </TileHeader>
      <TileBody>
        <DataList className="row">
          <OptionalDatumCol label="Final Campaign">
            {campaignFullName}
          </OptionalDatumCol>

          <OptionalDatumCol label="Final Campaign ID">
            {campaignId}
          </OptionalDatumCol>

          <OptionalDatumCol label="Final Campaign Country">
            {campaignCountry}
          </OptionalDatumCol>

          <OptionalDatumCol label={`Original ${aliases.affiliate}`}>
            {affiliateName}
          </OptionalDatumCol>

          <OptionalDatumCol label={`Original ${aliases.affiliate} ID`}>
            {affiliateIdFromNetwork}
          </OptionalDatumCol>
        </DataList>

        {adwordsData && (
          <React.Fragment>
            <h2>AdWords Data</h2>
            <DataList className="row">
              <OptionalDatumCol label="AdWords Ad">{adwordsData.ad}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Ad ID">{adwordsData.adId}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Ad Group">{adwordsData.group}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Ad Group ID">{adwordsData.groupId}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Campaign">{adwordsData.campaign}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Campaign ID">{adwordsData.campaignId}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Keywords">{adwordsData.keywords}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Keywords ID">{adwordsData.keywordsId}</OptionalDatumCol>

              <OptionalDatumCol label="AdWords Keyword Match Type">{adwordsData.keywordsMatchType}</OptionalDatumCol>
            </DataList>
          </React.Fragment>
        )}
      </TileBody>
    </Tile>
  );
};

CampaignData.propTypes = {
  aliases: PropTypes.shape({
    affiliate: PropTypes.string.isRequired
  }).isRequired,
  affiliateIdFromNetwork: PropTypes.string,
  affiliateName: PropTypes.string,
  campaignId: PropTypes.string,
  campaignFullName: PropTypes.string,
  campaignCountry: PropTypes.string,
  adwordsData: PropTypes.shape({
    ad: PropTypes.string,
    adId: PropTypes.string,
    group: PropTypes.string,
    groupId: PropTypes.string,
    campaign: PropTypes.string,
    campaignId: PropTypes.string,
    keywords: PropTypes.string,
    keywordsId: PropTypes.string,
    keywordsMatchType: PropTypes.string
  })
};

export default CampaignData;
